import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { API } from '../../App'

const AmcTopfundMan = () => {
    document.title = "Top Fund Manager";
    document.querySelector('meta[name="description"]').setAttribute('content', "Top Fund Manager");
    const [data,setData] = useState("")
    const {_id} = useParams()
    const getData = async() => {
        const response = await API.post("/amc/detail/topfundmanager",{amc_id:_id})
        setData(response.data.data.topFundMan)
    }
    useEffect(()=>{
        getData()
    },[])
    return (
        <div className='balance-webview top-fund'>
            <Container>
                <Row>
                    <Col xs={12}>
                        <div className="content" dangerouslySetInnerHTML={{__html: data}}></div>    
                    </Col>
                </Row>
            </Container >
        </div >
    )
}

export default AmcTopfundMan